import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
//#region src/hooks/useSendMessageMutation.ts
var r = (r) => {
	let i = n(), { api: a, keys: o } = e();
	return t({
		mutationFn: ({ conversationId: e, ...t }) => a.sendMessage(e ?? r, t),
		onSuccess: (e, t) => {
			let n = t.conversationId ?? r;
			i.invalidateQueries({ queryKey: o.messages(n) }), o.conversations && i.invalidateQueries({ queryKey: o.conversations() });
		}
	});
};
//#endregion
export { r as useSendMessageMutation };
